export function getStaticPagesConfig() {
    return {
        custom: {},
        palette: {},
    };
}
